import * as React from "react";
import { forwardRef } from "react";
import styled, { css } from "styled-components";
import { Icon } from "components/common";
import useIsDirty from "views/hooks/useIsDirty";
import { Button } from "components/bootstrap";
const StyledIcon = styled(Icon)(
  ({ theme, $isDirty }) => css`
    color: ${$isDirty ? theme.colors.variant.dark.warning : "default"};
  `
);
const SaveViewButton = ({ title, onClick, disabled = false }, ref) => {
  const isDirty = useIsDirty();
  return /* @__PURE__ */ React.createElement(Button, { title, ref, onClick, disabled }, /* @__PURE__ */ React.createElement(StyledIcon, { name: "save", type: isDirty ? "solid" : "regular", $isDirty: !disabled && isDirty }), " Save");
};
export default forwardRef(SaveViewButton);
